import { useEffect, useRef, useState } from "react";
import {
  CheckCircleOutlined,
  StopOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { checkUserStatus } from "../../Api/userStatus";
import popupSound from "../../assets/popup.mp3";
import { useGetUserData } from "../../hooks/useGetUserData";
import { useParams } from "react-router-dom";

const UserStatusPopup = () => {
  const [visible, setVisible] = useState(false);
  const [modalData, setModalData] = useState(null);
  const hasFetchedRef = useRef(false);
  const { slug } = useParams();
  const { data: user, isLoading } = useGetUserData(slug);

  useEffect(() => {
    const fetchStatus = async () => {
      // Prevent duplicate calls and ensure user is loaded
      if (hasFetchedRef.current || !user) return;
      hasFetchedRef.current = true;

      try {
        const status = await checkUserStatus(slug);
        const { skippedCount, remainingWarnings, isBlocked } = status;

        if (skippedCount > 0) {
          setModalData({ skippedCount, remainingWarnings, isBlocked });
          setVisible(true);

          // Play popup sound
          const audio = new Audio(popupSound);
          audio.play().catch((err) =>
            console.warn("Autoplay prevented or failed:", err)
          );
        }
      } catch (err) {
        console.error("Failed to check user status", err);
      }
    };

    fetchStatus();
  }, [user, slug]);

  if (!visible || isLoading || !user) return null;

  return (
    <div className="fixed bottom-8 left-2 md:left-8 z-50 animate-popup-grow">
      <div className="relative w-44  md:w-[350px]  bg-white shadow-xl p-3 pe-0 rounded-2xl text-sm text-gray-800 border border-primary transition-transform scale-100">
        <div className="absolute bottom-[-8px] left-3  md:left-4 w-4 h-4 bg-white transform rotate-45 border-r border-b border-primary"></div>

        <button
          onClick={() => setVisible(false)}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition"
          aria-label="Close"
        >
          <CloseOutlined />
        </button>

        <div className="flex items-center gap-2 mb-2">
          {modalData?.isBlocked ? (
            <StopOutlined className="text-red-500 md:text-lg" />
          ) : (
            <img
              src="https://res.cloudinary.com/dk2uh7sho/image/upload/v1751638211/communication_17850244_t5nfdy.gif"
className="w-6 md:w-12"              alt="popup"
            />
          )}
          <span className="font-semibold text-xs md:text-base">
            {modalData?.isBlocked ? "You are Blocked" : `Hello ${user?.firstName}`}
          </span>
        </div>

        <p className="text-[10px] md:text-base">
          For reminder, you skipped <b>{modalData?.skippedCount}</b> reservations.
          <br />
          Remaining warnings: <b>{modalData?.remainingWarnings}</b>
        </p>
      </div>
    </div>
  );
};

export default UserStatusPopup;
